import styled, { css } from 'styled-components';
import { layout, styledUtils, media } from '@prisjakt/ui-base';
import StoreLogo from '@prisjakt/ui-store-logo';
import Clickable from '@prisjakt/ui-clickable';

const BUTTON_MARGIN_UNFEATURED = 52;
const BUTTON_MARGIN_UNFEATURED_MOBILE = 44;

const sharedStyles = css`
  width: inherit;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  padding: ${layout.measurements.spacing050};
  margin-bottom: ${layout.measurements.spacing050};
  min-height: 47px;

  &::after {
    ${styledUtils.overlay()}
    border-radius: 5px;
    pointer-events: none;
    transition: background-color 150ms ease;
  }
`;

export const StoreLink = styled(Clickable)`
  ${sharedStyles};

  &:hover {
    &::after {
      background-color: rgba(0, 0, 0, 0.07);
    }
  }
`;

export const UnfeaturedStore = styled.div`
  ${sharedStyles};
`;

export const MissingPlaceHolder = styled(StoreLink)`
  height: 47px;
  justify-content: center;
  color: ${p => p.theme.text.primary};
`;

export const Logo = styled(StoreLogo)`
  margin-right: ${layout.measurements.spacing050};
  min-width: 90px;
`;

export const Count = styled.div`
  margin-left: ${layout.measurements.spacing025};
  color: ${p => p.theme.text.quaternary};
`;

export const PriceInformation = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

type PriceWrapperProps = {
  $featured: boolean;
};

export const PriceWrapper = styled.div<PriceWrapperProps>`
  margin-right: ${p => (!p.$featured ? `${BUTTON_MARGIN_UNFEATURED}px` : '0')};
  margin-left: ${layout.measurements.spacing025};
  ${media.smallOnly`
    margin-right: ${(p: PriceWrapperProps) =>
      !p.$featured
        ? `${BUTTON_MARGIN_UNFEATURED_MOBILE}px`
        : `-${layout.measurements.spacing050}`};
  `}
`;

export const OfferButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(59, 163, 212, 1);
  box-shadow: 0px 2px 4px rgba(5, 37, 46, 0.24);
  border-radius: ${layout.measurements.spacing050};
  margin-left: ${layout.measurements.spacing100};
  margin-top: -${layout.measurements.spacing100};
  margin-bottom: -${layout.measurements.spacing100};
  width: 36px;
  height: 36px;

  :hover {
    cursor: pointer;
  }

  svg {
    fill: rgba(255, 255, 255, 1);
    height: ${layout.measurements.spacing100};
  }
`;
